import { render, staticRenderFns } from "./multi-buttons.vue?vue&type=template&id=26128cef&scoped=true&"
import script from "./multi-buttons.vue?vue&type=script&lang=js&"
export * from "./multi-buttons.vue?vue&type=script&lang=js&"
import style0 from "./multi-buttons.vue?vue&type=style&index=0&id=26128cef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26128cef",
  null
  
)

export default component.exports